module.exports = __webpack_public_path__ + "images/fcacapital_smallac063a4506338112e4f92a91b8a30678.png";